import React from 'react';
// Redux
import { connect, ConnectedProps } from 'react-redux';
import { RootState } from 'src/store/rootReducer';
// constants
import ERROR_DETAILS from 'src/constants/errorDetailCode';
// components
import { ErrorLayout } from '../../components';
import EmailErrorLayout from './EmailErrorLayout';

export const EmissionErrorHandler = ({
  emissionErrorDetail,
}: Props): JSX.Element => {
  if (emissionErrorDetail === ERROR_DETAILS.evicertia) {
    return <EmailErrorLayout data-testid="email-error-layout" />;
  }
  return (
    <ErrorLayout
      data-testid="generic-error-layout"
      titleMessage="Ha ocurrido un error en el proceso de emisión"
    />
  );
};

export const mapStateToProps = (
  state: RootState,
): {
  emissionErrorDetail: string;
  emissionErrorCode: string;
} => ({
  emissionErrorDetail: state.emissionPolicy.emissionErrorDetail,
  emissionErrorCode: state.emissionPolicy.emissionErrorCode,
});

const connector = connect(mapStateToProps, {});
type Props = ConnectedProps<typeof connector>;

export default connector(EmissionErrorHandler);
